
const { activeCollectionId } = require('./handlePageType');
const Banner = require('./Banner');
const SubscribeTile = require('./SubscribeTile');
const SideNav = require('./SideNavigation');

function handleListingPage() {
  let layoutType;
  const body = document.querySelector('body');

  function handleBanner() {
    function getBannerSettings() {
      const { bannerSettings } = window.obData;

      if (!bannerSettings) {
        return null;
      }

      return bannerSettings;
    }

    const banner = new Banner(getBannerSettings());
    banner.init();
  }

  function handleSubTile(layout) {
    const subTile = new SubscribeTile(layout);
    subTile.init();
  }

  function handleSideNav() {
    const sideNav = new SideNav();
    sideNav.init();
  }

  function setGridLayout() {
    const { layoutSettings } = window.obData;

    for (const layout in layoutSettings) {
      let streamFound = false;

      for (let i = 0; i < layoutSettings[layout].length; i++) {
        if (layoutSettings[layout][i].indexOf(activeCollectionId) !== -1) {
          streamFound = true;
          layoutType = layout;
          body.classList.add(layout);
          break;
        }
      }

      if (streamFound) {
        break;
      }
    }
  }

  function handleVisibility() {
    body.querySelector('#hubs-container').style.opacity = '1';
  }

  function init() {
    try {
      setGridLayout();
      handleBanner();
      handleSideNav();
      handleSubTile(layoutType);
      handleVisibility();
    } catch (e) {
      handleVisibility();
    }
  }

  return init();
}

module.exports = handleListingPage;


// WEBPACK FOOTER //
// ./modules/handleListingPage.js